import { PaintRowDraft } from '../types'

/** Строка без колорантов и без порций не используется (например, форма CUT) и не проверяется. */
export function isRowUsed(draft: PaintRowDraft) {
    return draft.colorants.some(cell => cell.colorantDocumentId) || Boolean(draft.portions)
}
